import moment from "moment";

export function setSameHeights() {
    if (window.innerWidth >= 980) {
        $.each($('.sameheight'), function () {
            var that = $(this);
            var elems = $('.align', $(this));
            var biggestOuterHeight = 0;
            elems.removeAttr('style');
            $.each(elems, function () {
                if ($(this).outerHeight() > biggestOuterHeight) {
                    biggestOuterHeight = $(this).outerHeight();
                }
            });
            $.each(elems, function () {
                var deltaHeight = $(this).outerHeight() - $(this).height();
                $(this).height(biggestOuterHeight - deltaHeight);
            });
        });
    } else {
        $('.sameheight .align').height('auto');
    }
}

export function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

export function affixCalendar() {
    var calendar = $('.bk_calendar');
    if (calendar.length > 0) {
        if (window.innerWidth >= 980) {
            var objectTop = $('#bk_events_section').offset().top - 50;
            var objectBottom = objectTop + $('.bk_list').outerHeight(true) - calendar.outerHeight(true) - 20;
            var documentTop = $(window).scrollTop();
            var calendarWidth = $('.bk_calendar_section').width();
            if (documentTop > objectTop && documentTop <= objectBottom) {
                calendar.css({'position': 'fixed', 'width': calendarWidth, 'bottom': 'inherit', 'top': '50px'});
            } else if (documentTop > objectBottom) {
                calendar.css({'position': 'absolute', 'width': '100%', 'bottom': '20px', 'top': 'inherit'});
            } else {
                calendar.css({'position': 'absolute', 'width': '100%', 'bottom': 'inherit', 'top': 0});
            }
        } else {
            calendar.css({'position': 'inherit', 'width': 'inherit', 'bottom': 'inherit', 'top': 'inherit'});
        }
    }
}

export function affixBtn() {
    if ($('.bk_big_btn').length > 0) {
        if (window.innerWidth >= 980) {
            var objectTop = $('.bk_big_btn').offset().top - 35;
            var btn = $('.bk_more_info_btn');
            var objectBottom = objectTop + $('#bk_more_info').outerHeight(true) - btn.outerHeight(true) - 40;
            var documentTop = $(window).scrollTop();
            var btnWidth = $('.bk_big_btn').width() - 65;
            if (documentTop > objectTop && documentTop <= objectBottom) {
                btn.css({'position': 'fixed', 'width': btnWidth, 'bottom': 'inherit', 'top': '50px'});
            } else if (documentTop > objectBottom) {
                btn.css({'position': 'absolute', 'bottom': '20px', 'top': 'inherit'});
            } else {
                btn.css({'position': 'absolute', 'bottom': 'inherit', 'top': '20px'});
            }
        }
    }
}

export function updateQueryStringParam(key, value) {
    if(key === 'date') {
        ifDateIsBetween(value)
    }
    let baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
        urlQueryString = document.location.search,
        newParam = key + '=' + value,
        params = '?' + newParam;

    // If the "search" string exists, then build params from it
    if (urlQueryString) {
        var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
        var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

        if (typeof value === 'undefined' || value === null || value === '') { // Remove param if value is empty
            params = urlQueryString.replace(removeRegex, "$1");
            params = params.replace(/[&;]$/, "");

        } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
            params = urlQueryString.replace(updateRegex, "$1" + newParam);

        } else { // Otherwise, add it to end of query string
            params = urlQueryString + '&' + newParam;
        }
    }

    // no parameter was set so we don't need the question mark
    params = params === '?' ? '' : params;

    window.history.replaceState({}, "", baseUrl + params);
};

export function setPanelHeight() {
    //panel.parent().css('height', panel.outerHeight(true));
    //setSameHeights();
    updateQueryStringParam('event', eventId);
    updateQueryStringParam('date', moment($self.data('date')).format('DD-MM-YYYY'));
    $('.copy-link, .share-link').val(window.location.href);
    $('.socialsharing-link').each(function () {
        var link = $(this).attr('href');
        $(this).attr('href', link.replace('dynamic-fill', window.location.href));
    });
}

export function formDate(date) {
    var formedDate = new Date();
    if (date !== undefined) {
        formedDate = new Date(date);
    }
    var d = formedDate.getDate();
    var m = formedDate.getMonth() + 1;
    var y = formedDate.getFullYear();
    if (d < 10) {
        d = '0' + d;
    }
    if (m < 10) {
        m = '0' + m;
    }
    formedDate = d + '-' + m + '-' + y;
    return formedDate;
}


export function getQueryParameters() {
    var queryString = location.search.slice(1),
        params = {};

    queryString.replace(/([^=]*)=([^&]*)&*/g, function (_, key, value) {
        params[key] = value;
    });

    return params;
}


export function setQueryParameters(params) {
    var query = [],
        key, value;

    for(key in params) {
        if(!params.hasOwnProperty(key)) continue;
        value = params[key];
        query.push(key + "=" + value);
    }

    location.search = query.join("&");
}

export function updateURLParameter(url, param, paramVal){
    var newAdditionalURL = "";
    var tempArray = url.split("?");
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = "";
    if (additionalURL) {
        tempArray = additionalURL.split("&");
        for (var i=0; i<tempArray.length; i++){
            if(tempArray[i].split('=')[0] != param){
                newAdditionalURL += temp + tempArray[i];
                temp = "&";
            }
        }
    }

    var rows_txt = temp + "" + param + "=" + paramVal;
    return baseURL + "?" + newAdditionalURL + rows_txt;
}


export function ifDateIsBetween(currentDate) {
    const overlayContainer = $('#bookingKitContainer');

    setTimeout(() => {
        if(window.suspends) {
            let dateFrom = window.suspends.interval.from;
            let dateTo = window.suspends.interval.to;
            let infoText = window.suspends.info;

            let d1 = dateFrom.split("-");
            let d2 = dateTo.split("-");
            let c = currentDate.split("-");

            let from = new Date(d1[2], parseInt(d1[1])-1, d1[0]);
            let to   = new Date(d2[2], parseInt(d2[1])-1, d2[0]);
            let check = new Date(c[2], parseInt(c[1])-1, c[0]);

            if(check >= from && check <= to) {
                const infoObject = $('<div />', {
                    "class": 'suspend-info',
                    html: infoText
                });

                overlayContainer.prepend(infoObject)
                overlayContainer.addClass('suspended');
            } else {
                $('.suspend-info').remove();
                overlayContainer.removeClass('suspended');
            }
        }
    }, 1250);

}
